module.exports = __webpack_public_path__ + "static/media/edit.dd645d9e.png";